module.exports = __webpack_public_path__ + "static/media/carTajir.33970f44.png";